
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_viewport/desktop",
      function () {
        return require("private-next-pages/_viewport/desktop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_viewport/desktop"])
      });
    }
  